// components/NavigationEvents.jsx
import { useAuth } from "@/contexts/AuthContext";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

export default function NavigationEvents() {
  const navigate = useNavigate();
  const { logout } = useAuth();

  useEffect(() => {
    /* 🔴 Hard subscription block */
    const onSubscriptionBlocked = (e) => {
      const { redirect } = e.detail || {};

      toast.error("Your subscription is inactive");
      logout();
      navigate(redirect || "/subscription", { replace: true, state: {reason: "renewal"} });
    };

    /* 🟡 Subscription required */
    const onSubscriptionRequired = (e) => {
      toast.info("Please choose a subscription plan");
      navigate(e.detail?.redirect || "/subscription", { replace: true });
    };  

    /* 🔐 Auth expired */
    // const onAuthExpired = () => {
    //   toast.error("Session expired. Please login again.");
    //   // navigate("/", { replace: true });
    // };

    window.addEventListener("subscription-blocked", onSubscriptionBlocked);
    window.addEventListener("subscription-required", onSubscriptionRequired);
    // window.addEventListener("auth-expired", onAuthExpired);

    return () => {
      window.removeEventListener("subscription-blocked", onSubscriptionBlocked);
      window.removeEventListener("subscription-required", onSubscriptionRequired);
      // window.removeEventListener("auth-expired", onAuthExpired);
    };
  }, [navigate]);

  return null; // No UI
}
